
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import ShopImagesUpload from '@/views/shop/components/ShopImagesUpload.vue';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import VideoUModal from '@/components/video/VideoModal.vue';
import VideoUploadModal from '@/views/account-management/components/VideoUploadModal.vue';
import ShopService from '@/services/shop.service';
import CarService from '@/services/car.service';


@Component({
  components: {
    ShopImagesUpload,
    VideoUModal,
    VideoUploadModal,
  },
})
export default class LookVideoModal extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  title = '选择视频';

  @Prop()
  sourceType!: any;

  @Prop()
  shopId!: string;

  deleType = true;

  draftList = [];


  @Ref('videoUModal')
  videoUModal!: VideoUModal;

  @Ref('videoUploadModal')
  videoUploadModal!: VideoUploadModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(CarService)
  carService!: CarService;

  deleteObjs: any = [];

  total = 0;

  form = {
    page: 1,
    pageSize: 10,
  };

  data: any = {
    edit: [],
    add: [],
    delete: [],
  };

  p_type: any = '';

  albumId: any = '';

  activeKey: any = '1';

  draftKeys: any[] = [];

  @Ref('shopImagesUpload')
  shopImagesUpload!: ShopImagesUpload;

  init(name: string, type: any, data: any, albumId?: any) {
    this.title = name;
    this.p_type = type;
    this.visible = true;
    this.data = data;
    const { add, delete: del } = data;
    this.albumId = albumId;
    this.activeKey = '1';
    this.draftList = add;
    this.deleteObjs = del;
    this.selectedKeys = del.map((item: any) => item.resource_id);

    // this.listData = this.listDasssta;
    if (albumId) {
      const params = {
        albumId,
        page: 1,
        pageSize: 10,
        shopId: this.shopId,
      };
      this.getAlbumList(params);
    }
    if (this.sourceType === 'add') {
      this.activeKey = '5';
    }
  }


  async getAlbumList(params: any) {
    const res = await this.carService.getCarShopAlbumOfficialInfo(params);
    console.log(res);
    this.listData = res.list;
    this.total = res.total;
  }

  funDelete() {
    this.deleType = false;
  }

  /**
   * 同步状态
   */
  synStatus() {
    console.log('同步状态');
  }

  funTDelete() {
    this.deleType = true;
  }

  handleOk() {
    console.log(this.selectedKeys);
    this.visible = false;
    this.data.delete = this.deleteObjs;
    this.data.add = this.draftList;
    this.$emit('submit', this.p_type, this.data);
  }

  handleCancel() {
    this.visible = false;
    this.listData = [];
    this.total = 0;
  }

  uploadImage() {
    this.videoUploadModal.init(this.draftList);
  }

  playVideo(obj: any) {
    console.log(obj);
    this.videoUModal.open(obj.path);
  }

  callback(key: string) {
    console.log(key);
    this.activeKey = key;
    if (key === '5') {
      this.listData = this.draftList;
    } else {
      const params = {
        albumId: this.albumId,
        page: 1,
        pageSize: 10,
        shopId: this.shopId,
      };
      if (this.albumId) {
        this.getAlbumList(params);
      }
    }
  }
  listData: any = [];
  listDasssta: any = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  handleCheck(key: any): void {
    if (this.activeKey === '5') {
      const index = this.draftKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.draftKeys.splice(index, 1);
      } else {
        // 未选中，加入
        this.draftKeys.push(key.resource_id);
      }
    } else {
      const index = this.selectedKeys.indexOf(key.resource_id);
      if (index > -1) {
        // 已选中，取消
        this.selectedKeys.splice(index, 1);
        this.deleteObjs = this.deleteObjs.filter((item: any) => item.resource_id !== key.resource_id);
      } else {
        // 未选中，加入
        this.selectedKeys.push(key.resource_id);
        this.deleteObjs.push(key);
      }
    }
  }

  funSynch() {
    console.log('同步状态');
  }
  edit() {
    console.log('编辑');
  }
  dele() {
    console.log('删除');
  }
  lookReason() {
    console.log('查看失败原因');
  }
  changeVideo(img: any) {
    console.log(img);
    if (this.activeKey === '5') {
      this.listData = img;
    }
    this.draftList = img;
  }
  onChange(page: string) {
    console.log(page);
  }

  delteItem(key: any) {
    this.selectedKeys.push(key.resource_id);
    this.deleteObjs.push(key);
  }

  deleteImage() {
    this.draftKeys.forEach((element: any) => {
      this.draftList = this.draftList.filter((item: any) => item.resource_id !== element);
    });
    this.listData = this.draftList;
  }

  cancelPage() {
    console.log('取消');
    if (this.activeKey === '5') {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.draftKeys.filter((item) => !idsToRemove.has(item));
      this.draftKeys = result;
    } else {
      const idsToRemove = new Set(this.listData.map((item: any) => item.resource_id));
      const result = this.selectedKeys.filter((item) => !idsToRemove.has(item));
      const deleteObjs = this.deleteObjs.filter((item: any) => !idsToRemove.has(item.resource_id));
      this.selectedKeys = result;
      this.deleteObjs = deleteObjs;
    }
  }
}
